<div class="wrapper">
	<h2 class="title">{{ data.text }}</h2>
	<!-- <input
		matInput
		class="input-data"
		type="datetime-local"
		*ngIf="isActive"
		[formControl]="timeControl" />
	<div class="form-checkbox" *ngIf="isActive">
		<input type="checkbox" [formControl]="disablePermanently" />
		<h3>Do you want to disable Permanently?</h3>
	</div> -->
	<div class="footer-btn">
		<button class="dismiss" (click)="close()">
			<h3>{{ 'common.close' | translate }}</h3>
		</button>
		<!-- <button
			(click)="agree()"
			[disabled]="disablePermanently.invalid"
			*ngIf="isActive"
		>
			<h3>Disable Permanently</h3>
		</button> -->

		<button (click)="agree(3)" *ngIf="isActive">
			<h3>3h</h3>
		</button>
		<button (click)="agree(2)" *ngIf="isActive">
			<h3>2h</h3>
		</button>
		<button (click)="agree(1)" *ngIf="isActive">
			<h3>1h</h3>
		</button>
		<button (click)="agreeOn()" *ngIf="!isActive">
			<h3>{{ 'common.yes' | translate }}</h3>
		</button>
	</div>
</div>
